export default __webpack_public_path__ + "static/media/uobt.0a8a97d0.svg";